import {
  GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS,
  GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR,
} from './actionTypes';
import { APPLICATION_STATUS } from '../../../../constants/event-application-status';
import { formatDateStandard } from '../../../../utils';
import Api from '../../../../commons/api';

const controller = 'vendor-events';

export const getAllVendorEventsPaginatedSuccess = (data, paginationData) => ({
  type: GET_ALL_VENDOR_EVENTS_PAGINATED_SUCCESS,
  payload: { data, paginationData },
});

export const getAllVendorEventsPaginatedError = (error) => ({
  type: GET_ALL_VENDOR_EVENTS_PAGINATED_ERROR,
  payload: error,
});

export const setPaginationData = (paginationData) => ({
  type: 'SET_PAGINATION_DATA',
  payload: paginationData,
});

export const setLoading = (loading) => ({
  type: 'SET_LOADING',
  payload: loading,
});

export const fetchVendorEventsPaginated = async (dispatch, payload) => {
  try {
    const { page, count, search } = payload;
    const searchParam = search && search.trim() !== '' ? search.trim() : '';

    dispatch(setLoading(true));

    // Build query parameters for the new endpoint
    const params = new URLSearchParams({
      page: page?.toString() || '1',
      limit: (count || 10).toString(),
    });

    if (searchParam) {
      params.append('search', searchParam);
    }

    // Use the new dedicated endpoint (matching pattern from other vendor-events endpoints)
    const url = `/${controller}/${controller}/venue-applications?${params.toString()}`;
    console.log('Calling endpoint:', url);
    const { data: dataResponse } = await Api.get(url);
    console.log('dataResponse:', dataResponse);

    let { data } = dataResponse;

    data = data.map((item) => {
      if (item) {
        /* eslint-disable no-param-reassign */
        if (item.application_status !== APPLICATION_STATUS.APPROVED) item.status = '';
        /* eslint-disable no-param-reassign */
        if (item.event?.parameters_event?.event_date) {
          item.event.parameters_event.event_date = formatDateStandard(
            item.event.parameters_event.event_date,
          );
        }
      }
      return item;
    });

    dispatch(setLoading(false));

    const paginationData = {
      count: dataResponse.count,
      total: dataResponse.total,
      page: dataResponse.page,
      pageCount: dataResponse.pageCount,
      search: searchParam,
    };

    dispatch(getAllVendorEventsPaginatedSuccess(data, paginationData));
  } catch (error) {
    console.error('fetchVendorEventsPaginated', error);
    dispatch(setLoading(false));
    dispatch(getAllVendorEventsPaginatedError(error));
  }
};
